































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'ItemExportPicker',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    totalItemCount: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      showDropdown: false,
    }
  },

  computed: {
    action(): string {
      return `Export ${this.itemTypeNamePlural}`
    },
    hasItems(): boolean {
      return this.totalItemCount && this.totalItemCount !== 0
    },
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
    itemTypeNamePlural(): string {
      return TextAssistant.itemPluralName(this.entityType)
    },
    itemTypeNameSingular(): string {
      return TextAssistant.itemSingularName(this.entityType)
    },
    itemCountText(): string {
      if (this.totalItemCount === 1) {
        return `One ${this.itemTypeNameSingular.toLowerCase()}`
      } else {
        return `All ${
          this.totalItemCount
        } ${this.itemTypeNamePlural.toLowerCase()}`
      }
    },
  },

  methods: {
    closeDropdown() {
      this.$messaging.showSuccess('Your export is downloading.')
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
    getExportLink(includeHistory: boolean): string {
      const root =
        process.env.VUE_APP_API_URL +
        `${this.accountID}/${TextAssistant.itemPluralName(
          this.entityType,
        )}/search/export?`

      const params = Object.keys(this.$route.query)
        .map(key => key + '=' + encodeURIComponent(this.$route.query[key]))
        .join('&')

      let entityParam = `&internal_project_ids=${this.entityId}`

      if (this.entityType === EEntities.MAILBOXES) {
        entityParam = `&mailbox_ids=${this.entityId}`
      }
      return (
        root +
        params +
        entityParam +
        '&file_type=csv&include_history=' +
        String(includeHistory)
      )
    },
  },
})
